module.exports = __webpack_public_path__ + "static/025.thumb-bd696199fdad9748a5c78c203743c337.jpg";